import { Carousel } from 'react-bootstrap'
import React, { useEffect, useState } from 'react'
import { collection, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../firebaseConfig/firebase'

const CarouselShow = () => {
    const carouselCollection = collection(db, "carousel")

    const [carousel, setCarousel] = useState([])
    const getCarousel = async () => {

        if (carousel.length === 0) {

            const carouselQuery = query(carouselCollection, where("state", "==", true));
            const carouselDocs = await getDocs(carouselQuery)
            if (carouselDocs.docs.length > 0) {
                setCarousel(
                    carouselDocs.docs
                )
            } else {
                setCarousel([])
            }
        }

    }

    useEffect(() => {
        getCarousel()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Carousel
            interval={5000}
        >
            {
                carousel.map((item) => (
                    <Carousel.Item key={item.id}
                        style={{
                            position: "relative",
                            height: "300px",
                            overflow: "hidden"
                        }}
                    >
                        <Carousel.Caption
                            style={{
                                backgroundColor: "rgba(0,0,0,0.5)",
                                position: "absolute",
                                bottom: "10",
                                left: "0",
                                right: "0",
                                padding: "10px",
                                color: "white"
                            }}
                        >
                            <h3>{item.data().text}</h3>
                        </Carousel.Caption>
                        <img
                            className="d-block w-100"
                            src={item.data().image}
                            alt="Imagen"
                            style={{ objectFit: "cover", objectPosition: "center", width: "100%", height: "auto" }}
                        />

                    </Carousel.Item>
                ))
            }
        </Carousel>
    )
}

export default CarouselShow